import React, { useEffect, useMemo, useRef } from 'react';
import { arrayOf, bool, func, node, object, oneOf, shape, string } from 'prop-types';
import classNames from 'classnames';
import { FieldCustomSelect, InlineTextButton, Modal, ValidationError } from '..';
import css from './FieldWorkerExperience.module.css';
import {
  employmentType,
  languageSelectOptions,
  workingStatus,
} from '../../marketplace-custom-config';
import { FormattedMessage, injectIntl } from 'react-intl';
import { FieldArray } from 'react-final-form-arrays';
import { BsPlusLg } from 'react-icons/bs';
import { FiEdit3, FiMinus } from 'react-icons/fi';
import { ReactComponent as CloseIcon } from '../../assets/svg/close.svg';
import { WorkerExpForm } from '../../forms';
import { useState } from 'react';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { ReactComponent as Dot } from '../../assets/svg/Dot.svg';
const textfield = 'textfield';
const errorTextField = 'errorTextField';

const customLabel = Object.values(languageSelectOptions).reduce((pre, curnt) => {
  pre[curnt.value] = string.isRequired;
  return pre;
}, {});

const nativeLangOptions = Object.keys(customLabel);

const defaultValueForJobCategory = { category: null, subCategory: null };

const FieldWorkerExperienceComponent = props => {
  const {
    rootClassName,
    className,
    errorClassName,
    titleClassName,
    id,
    onChange,
    name,
    userNativeLang,
    intl,
    formApi,
    values,
    onManageDisableScrolling,
  } = props;

  const [showWorkerExpModal, setShowWorkerModal] = useState(false);
  const expFormInitialValues = useRef({});
  const editIndx = useRef(-1);
  const [viewFullDescription, setViewFullDescription] = useState(false);
  // job category
  // const jobCategoryLabel = intl.formatMessage({
  //   id: 'FieldWorkerJobCateogry.jobCategoryLabel',
  // });
  // const jobCategoryPlaceholder = intl.formatMessage({
  //   id: 'FieldWorkerJobCateogry.jobCategoryPlaceholder',
  // });

  // // job sub category
  // const jobSubcategoryLabel = intl.formatMessage({
  //   id: 'FieldWorkerJobCateogry.jobSubcategoryLabel',
  // });
  // const jobSubcategoryPlaceholder = intl.formatMessage({
  //   id: 'FieldWorkerJobCateogry.jobSubcategoryPlaceholder',
  // });

  const addJobBtnLabel = intl.formatMessage({ id: 'FieldWorkerJobExperience.addMoreExpBtn' });

  const addMoreJobExp = event => {
    event.preventDefault();
    event.stopPropagation();

    editIndx.current = -1;
    expFormInitialValues.current = {};
    setShowWorkerModal(true);
  };

  const closeWorkerModal = () => {
    editIndx.current = -1;
    setShowWorkerModal(false);
  };

  const handleWorkerExpSubmit = values => {
    const {
      mutators: { push, update },
    } = formApi;
    if (editIndx.current >= 0) {
      update(name, editIndx.current, values);
    } else {
      push(name, { ...values, id: uuidv4() });
    }
    editIndx.current = -1;
    closeWorkerModal();
  };

  const handleWorkExpRemove = (indx, event) => {
    event.preventDefault();
    const {
      mutators: { remove },
    } = formApi;
    remove(name, indx);
  };

  const handleWorkExpEdit = (indx, values, event) => {
    event.preventDefault();
    editIndx.current = indx;
    const { workingStatus: jobStatus, ...restValues } = values;
    expFormInitialValues.current = {
      ...restValues,
      workingStatus:
        jobStatus === workingStatus.currentlyWorking ? [workingStatus.currentlyWorking] : [],
    };
    setShowWorkerModal(true);
  };

  const classes = classNames(rootClassName || css.root, className, {
    [errorClassName]: !!errorClassName && hasError,
  });

  const currentWorkingLabel = intl.formatMessage({ id: 'FieldWorkerJobExperience.toCurrent' });
  const toLabel = intl.formatMessage({ id: 'FieldWorkerJobExperience.to' });
  const at = intl.formatMessage({ id: 'FieldWorkerJobExperience.at' });
  const editBtnLabel = intl.formatMessage({ id: 'FieldWorkerJobExperience.editBtn' });
  const removeBtnLabel = intl.formatMessage({ id: 'FieldWorkerJobExperience.removeBtn' });

  const titleClasses = classNames(css.titleWrapper, titleClassName);

  return (
    <React.Fragment>
      <div className={classes} id={id}>
        <div className={titleClasses}>
          <h2 className={css.heading}>
            <FormattedMessage id="FieldWorkerJobExperience.expHeading" />
          </h2>
          <p className={css.helperText}>
            <FormattedMessage id="FieldWorkerJobExperience.expSubHeading" />
          </p>
        </div>
        <FieldArray name={name}>
          {({ fields }) => {
            const { value } = fields;
            return fields.map((fieldName, indx) => {
              const savedDetails = value[indx];
              const {
                jobTitle,
                companyName,
                jobType,
                jobStartDate,
                workingStatus: jobWorkStatus,
                jobEndDate,
                startYear,
                endYear,
                jobDesc,
              } = savedDetails;

              const jobTypeLabel = employmentType[jobType].label[userNativeLang];
              const momentJobStartDate = moment(jobStartDate).locale(userNativeLang);
              const momentJobEndDate = jobEndDate && moment(jobEndDate).locale(userNativeLang);
              const totalMonthsWorkedTillNow = momentJobEndDate
                ? moment(jobEndDate).diff(jobStartDate, 'months')
                : moment().diff(jobStartDate, 'months');

              const totalWorkingMonthLabel = intl.formatMessage(
                { id: 'FieldWorkerJobExperience.workingMonth' },
                { count: totalMonthsWorkedTillNow }
              );
              // console.log(787, momentJobStartDate, momentJobEndDate);
              const startMonth = momentJobStartDate.format('MMM');
              const endMonth = momentJobEndDate && momentJobEndDate.format('MMM');
              const workingYearLabel =
                jobWorkStatus === workingStatus.currentlyWorking || !jobEndDate
                  ? `${startMonth} ${startYear} ${currentWorkingLabel} (${totalWorkingMonthLabel})`
                  : `${startMonth} ${startYear} ${toLabel}  ${endMonth} ${endYear} (${totalWorkingMonthLabel})`;

              return (
                <div key={fieldName} className={css.fieldParentContainer}>
                  <div className={css.heading}>
                    <div className={css.topHeading}>
                      <h3>{jobTitle}</h3>
                      <div className={css.editRemoveBtnDiv}>
                        <InlineTextButton
                          type="button"
                          onClick={handleWorkExpEdit.bind(null, indx, savedDetails)}
                        >
                          <FiEdit3 />
                          <span>{editBtnLabel}</span>
                        </InlineTextButton>
                        <InlineTextButton
                          type="button"
                          onClick={handleWorkExpRemove.bind(null, indx)}
                        >
                          <FiMinus />
                          <span>{removeBtnLabel}</span>
                        </InlineTextButton>
                      </div>
                    </div>
                    <p>
                      {at} {companyName}
                    </p>
                    <div className={css.jobTypeDiv}>
                      <span>{jobTypeLabel}</span>
                      <Dot />
                      <span>{workingYearLabel}</span>
                    </div>
                  </div>
                  <div className={css.footer}>
                    {/* <p>{jobDesc}</p> */}
                    {viewFullDescription ? <p>{jobDesc}</p> : <span>{jobDesc}</span>}
                    {/* {viewFullDescription ? (
                      <button
                        className={css.moreLess}
                        type="button"
                        onClick={() => {
                          
                          setViewFullDescription(!viewFullDescription);
                        }}
                      >
                        See Less
                      </button>
                    ) : (
                      <button
                        className={css.moreLess}
                        type="button"
                        onClick={() => {
                         
                          setViewFullDescription(!viewFullDescription);
                        }}
                      >
                        See More
                      </button>
                    )} */}
                  </div>
                </div>
              );
            });
          }}
        </FieldArray>
        <InlineTextButton type="button" className={css.addMoreJobBtn} onClick={addMoreJobExp}>
          <BsPlusLg className={css.icon} />
          <span className={css.text}>{addJobBtnLabel}</span>
        </InlineTextButton>
      </div>
      <Modal
        id={`FieldWorkerExp.${id}`}
        className={css.FieldWorkerExpModal}
        isOpen={showWorkerExpModal}
        onClose={closeWorkerModal}
        onManageDisableScrolling={onManageDisableScrolling}
        usePortal
        showCloseButton={false}
        contentClassName={css.modalContent}
      >
        <CloseIcon onClick={() => closeWorkerModal()} />
        <WorkerExpForm
          onSubmit={handleWorkerExpSubmit}
          userNativeLang={userNativeLang}
          onCancel={closeWorkerModal}
          initialValues={expFormInitialValues.current}
        />
      </Modal>
    </React.Fragment>
  );
};

FieldWorkerExperienceComponent.defaultProps = {
  rootClassName: null,
  className: null,
  titleClassName: null,
  errorClassName: null,
  userNativeLang: languageSelectOptions.en.value,
  values: [],
};

FieldWorkerExperienceComponent.propTypes = {
  rootClassName: string,
  className: string,
  errorClassName: string,
  titleClassName: string,
  onChange: func,

  // Label is optional, but if it is given, an id is also required so
  // the label can reference the input in the `for` attribute
  id: string.isRequired,
  name: string.isRequired,

  formApi: object.isRequired,
  userNativeLang: oneOf(nativeLangOptions).isRequired,
  onManageDisableScrolling: func.isRequired,
};

const FieldWorkerExperienceComp = injectIntl(FieldWorkerExperienceComponent);

const FieldWorkerExperience = props => {
  return <FieldWorkerExperienceComp {...props} />;
};

export default FieldWorkerExperience;

// {label ? <label htmlFor={id}>{label}</label> : null}
//       {isSearchable ? (
//         <React.Fragment>
//           <input
//             id={id}
//             value={!!selectedValue && !showOptions ? selectedValue.label : search}
//             placeholder={placeholder}
//             onChange={handleSearchChange}
//             className={css.selectInput}
//             onFocus={handleOnFocus}
//           />
//           <button
//             type="button"
//             onClick={toggleOptions}
//             className={classNames(css.arrowBtn, { [css.errorArrowBtn]: hasError })}
//             ref={arrowBtnRefCallback}
//           >
//             {showOptions ? <ArrowUp className={css.icon} /> : <ArrowDown className={css.icon} />}
//           </button>
//         </React.Fragment>
//       ) : (
//         <button
//           type="button"
//           id={id}
//           className={classNames(css.selectBtn, { [css.emptySelectBtn]: !selectedValue })}
//           onClick={toggleOptions}
//         >
//           <span className={css.text}>{!!selectedValue ? selectedValue.label : placeholder}</span>
//           {showOptions ? <ArrowUp className={css.icon} /> : <ArrowDown className={css.icon} />}
//         </button>
//       )}
//       {showOptions && (
//         <div className={css.optionsContainer}>
//           <ul className={css.optionsWrapper}>
//             {filteredOptions.map(data => {
//               return (
//                 <li
//                   key={data.value}
//                   className={classNames({
//                     [css.selectedOption]: !!selectedValue && data.value === selectedValue.value,
//                   })}
//                 >
//                   <button type="button" onClick={handleOptionClick.bind(null, data)}>
//                     <span>
//                       {typeof data.label === 'string' ? data.label : data.label[userNativeLang]}
//                     </span>
//                   </button>
//                 </li>
//               );
//             })}
//             {filteredOptions.length === 0 && (
//               <li className={css.noSearchOption}>
//                 <button type="button" onClick={handlenoOptionClick}>
//                   {intl.formatMessage({ id: noOptionMsgId })}
//                 </button>
//               </li>
//             )}
//           </ul>
//         </div>
//       )}
//       <ValidationError fieldMeta={meta} />
